<main>
    <mat-card>
      <mat-card-title>{{ "MOBILE_APP.MY_TASKS.TITLE" | translate }}</mat-card-title>
          <div>{{title}}</div>
          <div>{{description}}</div>
          <div>{{ "MOBILE_APP.MY_TASKS.OBJECT" | translate }} {{object}}</div>
          <div>{{ "MOBILE_APP.MY_TASKS.CREATED_BY" | translate }} <strong>{{createdBy}}</strong></div>
          <div>{{ "MOBILE_APP.MY_TASKS.RESPONSIBLE" | translate }} {{responsible}}</div>
          <div><mat-checkbox [checked]="accepted === 1">{{ "MOBILE_APP.MY_TASKS.ACCEPTED" | translate }}</mat-checkbox></div>
      <mat-dialog-actions>
          <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.close' | translate"></button>
        </mat-dialog-actions>
    </mat-card>
</main>